
import { importSync as i } from '@embroider/macros';
let d = window.define;
import "@embroider/macros/-embroider-implicit-modules.js";
import "ember-cli-test-loader/-embroider-implicit-modules.js";
